import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import { UseForm } from "../../../hooks";
import { UsePostDataForm, UsePutDataForm, UseGet } from "../../../hooks/api";
import { VIDEO } from "../../../routes/routesNames";

const UseFormVideo = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isReady, setIsReady] = useState(false);

  let isEnable = true;

  const { isLoading: isLoadingPostDataForm, handlePostDataForm } =
    UsePostDataForm();
  const { isLoading: isLoadingPutDataForm, handlePutDataForm } =
    UsePutDataForm();
  const { form, setForm, handleChange } = UseForm();
  const { isLoading: isLoadingEx, data: dataEx } = UseGet("/v1/jabatan")

  useEffect(() => {
    setForm({
      ...form,
      status: "arsip",
      is_trending: false,
    });
    if (props.type === "put") {
      if (location.state) {
        let dataTag = [];

        location.state.tag.map((data) => {
          dataTag.push({
            id: data,
            text: data,
          });
        });

        setForm({
          ...location.state,
          tag: dataTag,
        });
        setIsReady(true);
      } else {
        navigate(VIDEO);
      }
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log("qwerty");
    let dataTag = [];

    form.tag.map((data) => {
      dataTag.push(data.text);
    });

    if (props.type === "post") {
      if (
        form.thumbnail.type === "image/jpeg" ||
        form.thumbnail.type === "image/png"
      ) {
        let te = form.type_expert;
        let pt = form.province_type;
        if (te === "semua") {
          te = "Semua";
        }
        if (pt === "semua") {
          pt = "Semua";
        }
        let params = {
          url: "/v1/vidio",
          form: {
            ...form,
            tag: dataTag,
            type_expert: te,
            province_type: pt,
            status: "publish",
            jns_tanaman: form.jenis_tanaman,
          },
          navigation: VIDEO,
        };
        // console.log(params);
        if (form.tag.length < 1) {
          swal("Gagal", "Tag harus diisi", "error");
        } else {
          handlePostDataForm(params);
        }
      } else {
        swal("Gagal", "File Harus Gambar", "error");
      }
    } else {
      if (typeof form.thumbnail !== "string") {
        if (
          form.thumbnail.type === "image/jpeg" ||
          form.thumbnail.type === "image/png"
        ) {
          let params = {
            url: "/v1/vidio?_id=" + form._id,
            form: {
              ...form,
              tag: dataTag,
            },
            navigation: VIDEO,
          };
          if (form.tag.length < 1) {
            swal("Gagal", "Tag harus diisi", "error");
          } else {
            handlePutDataForm(params);
          }
        } else {
          swal("Gagal", "File Harus Gambar", "error");
        }
      } else {
        let params = {
          url: "/v1/vidio?_id=" + form._id,
          form: {
            ...form,
            tag: dataTag,
          },
          navigation: VIDEO,
        };
        delete params.form.thumbnail;
        if (form.tag.length < 1) {
          swal("Gagal", "Tag harus diisi", "error");
        } else {
          handlePutDataForm(params);
        }
      }
    }
  };

  // if(form.terbitkan === 'sekarang'){
  //     isEnable = form.title  && form.link_vidio  &&   form.jenis_opt.length &&  form.jenis_tanaman.length &&  form.tag.length ;
  // }else{
  //     isEnable = form.title  && form.link_vidio  &&   form.jenis_opt.length &&  form.jenis_tanaman.length &&  form.tag.length && form.tanggal_publish && form.waktu_publish ;
  // }

  return {
    isLoadingPostDataForm,
    isLoadingPutDataForm,
    form,
    isReady,
    isEnable,
    dataEx,
    handleChange,
    handleSubmit,
    navigate,
  };
};

export default UseFormVideo;
